import {
  Facebook,
  Instagram,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";
import { Link } from "react-router-dom";

const linkClass =
  "text-white/80 transition-colors duration-200 hover:text-white";

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-white">
      <div className="mx-auto px-4 pt-12 pb-10 md:px-10">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <h2 className="mb-1 text-3xl font-bold text-white">ZAAR</h2>
            <p className="font-poppins mb-4 text-sm text-white/60">
              Zar Leathers
            </p>
            <p className="mb-6 leading-relaxed text-white/70">
              ZAAR creates premium lifestyle essentials — including leather bags,
              wallets, and thoughtfully designed accessories — crafted with
              quality, purpose, and enduring style.
            </p>
            <div className="flex space-x-3">
              <a
                href={process.env.REACT_APP_FACEBOOK}
                className="rounded-full border border-white/30 p-3 text-white transition-colors duration-200 hover:border-white hover:bg-white hover:text-[#111111]"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={process.env.REACT_APP_INSTAGRAM}
                className="rounded-full border border-white/30 p-3 text-white transition-colors duration-200 hover:border-white hover:bg-white hover:text-[#111111]"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="mb-6 text-xl font-semibold text-white">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className={linkClass}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className={linkClass}>
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className={linkClass}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-6 text-xl font-semibold text-white">
              Customer Service
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/track-order" className={linkClass}>
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/shipping" className={linkClass}>
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/returns-exchanges" className={linkClass}>
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link to="/privacy" className={linkClass}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className={linkClass}>
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-6 text-xl font-semibold text-white">Find Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="mt-1 h-5 w-5 shrink-0 text-white" />
                <p className="leading-relaxed text-white/80">
                  DHA Phase 9
                  <br />
                  Lahore, Punjab
                  <br />
                  Pakistan
                </p>
              </div>

              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 shrink-0 text-white" />
                <a
                  href={`https://wa.me/${process.env.REACT_APP_PHONE}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  {process.env.REACT_APP_PHONE}
                </a>
              </div>

              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 shrink-0 text-white" />
                <a
                  href={`mailto:${process.env.REACT_APP_EMAIL}`}
                  className={linkClass}
                >
                  zaarleather@gmail.com
                </a>
              </div>
            </div>

            <div className="mt-6">
              <h4 className="mb-3 text-lg font-medium text-white">
                Business Hours
              </h4>
              <div className="space-y-1 text-sm text-white/70">
                <p>Monday - Saturday: 9:00 AM - 10:00 PM</p>
                <p>Sunday: 12:00 PM - 5:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15 py-4 text-center">
        <div className="text-sm text-white/60">
          © 2026 ZAAR. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
